import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=c96e3c46&scoped=true&lang=pug&"
import script from "./EmployeeForm.vue?vue&type=script&lang=ts&"
export * from "./EmployeeForm.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&id=c96e3c46&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96e3c46",
  null
  
)

export default component.exports